
import { defineComponent, SetupContext, PropType } from "vue";
import CommonHorizontalRecipeListItem from "@/components/commonRecipe/CommonHorizontalRecipeListItem.vue";
import { CommonRecipe } from "@/types/commonRecipe";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "CommonHorizontalRecipeList",
  components: { CommonHorizontalRecipeListItem },
  props: {
    /**
     * レシピリストに表示するデータの配列
     */
    recipes: {
      type: Array as PropType<CommonRecipe[]>,
      default: () => []
    },
    /**
     * 表示するレシピ件数(-1:制限なし)
     */
    limitCount: {
      type: Number,
      default: -1,
      required: true
    },
    /**
     * 食材表示
     */
    isFoods: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    /**
     * レシピ押下時に id と type を通知する
     *
     * @param {number} recipeId - レシピID
     * @param {string} type - レシピの種別
     */
    const selectRecipe = (recipeId: number, type: string) => {
      context.emit("on-click", recipeId, type);
    };

    /**
     * レシピリストを取得する
     */
    const getRecipes = (recipes: CommonRecipe[]) => {
      if (recipes != null) {
        NativeClient.sendDebugLog("CommonHorizontalRecipeList isn't null");
        if (props.limitCount != -1) {
          return recipes.slice(0, props.limitCount);
        } else {
          return recipes;
        }
      } else {
        NativeClient.sendDebugLog("CommonHorizontalRecipeList is null");
        return null;
      }
    };

    return {
      selectRecipe,
      getRecipes
    };
  }
});
